<pdq-tabs-group class="product-upgrade-tabs" variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="tab.disabled"></pdq-tab>
  }
</pdq-tabs-group>

<div class="checkout-product-upgrade">
  <div class="content">
    <form [formGroup]="formGroup">
      @switch (activeTab) {
        @case (ProductUpgradeTab.SETTINGS) {
          <product-upgrade-settings
            [formGroup]="formGroup"
            [restrictionsRules]="restrictionsRules"
            [entities]="entities"
            [formArrayFieldName]="formArrayFieldName">
          </product-upgrade-settings>
        }
        @case (ProductUpgradeTab.APPEARANCE) {
          <product-upgrade-appearance
            [formGroup]="formGroup"
            [dynamicFieldsAutocompleteOptions$]="dynamicFieldsAutocompleteOptions$">
          </product-upgrade-appearance>
        }
        @case (ProductUpgradeTab.PRODUCT_SELECTION) {
          <product-upgrade-product-selection
            [formGroup]="formGroup"
            [loadedValues]="loadedExtension?.template"
            [layoutSwitched]="!!layoutSwitchSnapshot"
            (switchToFocusedOffer)="switchToFocusedOffer()"
            (undoLayoutSwitch)="undoLayoutSwitch()">
          </product-upgrade-product-selection>
        }
        @case (ProductUpgradeTab.DISPLAY_CONDITIONS) {
          <div class="section">
            <pdq-heading element="h5">Display Conditions</pdq-heading>
            <div class="controls-wrapper">
              <p>This Upgrade Will Only Appear If:</p>
              <pdq-rules-dynamic-form
                [formGroup]="formGroup"
                [formArrayFieldName]="formArrayFieldName"
                [rules]="restrictionsRules"
                [entities]="entities"
                [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
            </div>
          </div>
        }
      }
    </form>
  </div>
</div>
